import React from 'react';
import type { IApp } from '@todesktop/shared';
import { AppIconFallback, AppIconImage } from './NavStyles';

export const getAppInitials = (name: string | undefined): string => {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};

export const NavAppIcon: React.FC<{ app: Pick<IApp, 'icon' | 'name'> }> = ({
  app,
}) =>
  app.icon ? (
    <AppIconImage src={app.icon} alt="" />
  ) : (
    <AppIconFallback aria-hidden>{getAppInitials(app.name)}</AppIconFallback>
  );
